/**
 * @generated SignedSource<<943118384447fa87db6a50069ed0bb22>>
 * @relayHash 0beaada86e70eaaad027662c48eb40c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a3b9fd494c7ce2f7aee7f54e62b16046d6c98869d96a50c4e62214e7d1dd66c9

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type RealtimeUpdaterSubscription$variables = {
  cloudId: string;
  projectId: string;
};
export type RealtimeUpdaterSubscription$data = {
  readonly jira: {
    readonly onIssueCreatedByProjectNoEnrichment: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type RealtimeUpdaterSubscription = {
  response: RealtimeUpdaterSubscription$data;
  variables: RealtimeUpdaterSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectId",
            "variableName": "projectId"
          }
        ],
        "concreteType": "JiraIssueCreatedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueCreatedByProjectNoEnrichment",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "RealtimeUpdaterSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RealtimeUpdaterSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "a3b9fd494c7ce2f7aee7f54e62b16046d6c98869d96a50c4e62214e7d1dd66c9",
    "metadata": {},
    "name": "RealtimeUpdaterSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "0abc9b7a53072c396be9b57d67d7e0cb";

export default node;
